import React from 'react';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

class AdditionalTools extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
    };
  }

  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  render() {
    return (
      <React.Fragment>
        <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
          <DropdownToggle caret color="primary" className="btn btn-sm btn-primary">
            Action
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => this.props.triggerAction('suspended')}>Suspend</DropdownItem>
            <DropdownItem onClick={() => this.props.triggerAction('active')}>Activate</DropdownItem>

            <DropdownItem onClick={() => this.props.addTags()}>Add to Lists</DropdownItem>
          </DropdownMenu>
        </ButtonDropdown>
        {/* <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
          <DropdownToggle caret color="primary" className="btn btn-sm btn-primary">
            Download Report
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem>CSV</DropdownItem>
            <DropdownItem>PDF</DropdownItem>
            <DropdownItem>Microsoft Excel (.xlsx)</DropdownItem>
          </DropdownMenu>
        </ButtonDropdown> */}
      </React.Fragment>
      
    );
  }
}

export default AdditionalTools;
